/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_positionManager",
                type: "address",
                internalType: "contract INonfungiblePositionManager",
            },
            {
                name: "_leverage",
                type: "address",
                internalType: "contract UniswapV3Leverage",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "factory",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IUniswapV3Factory",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "leverage",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract UniswapV3Leverage",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "mint",
        inputs: [
            {
                name: "mintParams",
                type: "tuple",
                internalType: "struct INonfungiblePositionManager.MintParams",
                components: [
                    {
                        name: "token0",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "token1",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "fee",
                        type: "uint24",
                        internalType: "uint24",
                    },
                    {
                        name: "tickLower",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "tickUpper",
                        type: "int24",
                        internalType: "int24",
                    },
                    {
                        name: "amount0Desired",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1Desired",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount0Min",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1Min",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "recipient",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "deadline",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "initParams",
                type: "tuple",
                internalType: "struct UniswapV3LeveragedPosition.PositionInitParams",
                components: [
                    {
                        name: "tokenId",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "tokenToBorrow",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "amountToBorrow",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "flashLoanProvider",
                        type: "address",
                        internalType: "contract IERC3156FlashLender",
                    },
                    {
                        name: "assetConverter",
                        type: "address",
                        internalType: "contract IAssetConverter",
                    },
                    {
                        name: "owner",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "maxSwapSlippage",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "positionManager",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract INonfungiblePositionManager",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "error",
        name: "AddressEmptyCode",
        inputs: [
            {
                name: "target",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "AddressInsufficientBalance",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "FailedInnerCall",
        inputs: [],
    },
    {
        type: "error",
        name: "SafeERC20FailedOperation",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
        ],
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class PositionManagerLeverageWrapper__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_positionManager, _leverage, overrides) {
        return super.deploy(_positionManager, _leverage, overrides || {});
    }
    getDeployTransaction(_positionManager, _leverage, overrides) {
        return super.getDeployTransaction(_positionManager, _leverage, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
PositionManagerLeverageWrapper__factory.bytecode = _bytecode;
PositionManagerLeverageWrapper__factory.abi = _abi;
//# sourceMappingURL=PositionManagerLeverageWrapper__factory.js.map